import {
  fetchChatsGetArchivedChatsDesktop,
  IChatsGetArchivedChatsDesktopRequest,
  TChatsGetArchivedChatsDesktopResponse,
} from '../repositories/chats/v1/chats/get-archived-chats-desktop';
import { TContext } from '../types/context';

type TFetchArchivedChatsParams = {
  parameters: IChatsGetArchivedChatsDesktopRequest;
  cookies?: string;
};

export async function fetchArchivedChats(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchArchivedChatsParams,
) {
  try {
    const { response, statusCode }: TChatsGetArchivedChatsDesktopResponse = await fetchChatsGetArchivedChatsDesktop({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      return null;
    }

    return response.chats;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchArchivedChats.ts [fetchArchivedChats]',
      message: 'Не удалось получить список архивных чатов',
    });

    return null;
  }
}
